import { useNavigate } from "react-router-dom";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from "recharts";
import RecentActivities from "../../features/dashboard/recentActivities";

const kpiData = {
  totalUsers: 1250,
  newUsers: 45,
  newListing: 32,
  totalListedProducts: 3420,
  totalRevenue: 58650,
};

const usersProductsData = [
  { name: "Mon", users: 120, products: 35 },
  { name: "Tue", users: 210, products: 42 },
  { name: "Wed", users: 180, products: 38 },
  { name: "Thu", users: 300, products: 55 },
  { name: "Fri", users: 260, products: 49 },
  { name: "Sat", users: 140, products: 22 },
  { name: "Sun", users: 170, products: 28 },
];

const revenueData = [
  { name: "Mon", revenue: 5200 },
  { name: "Tue", revenue: 7800 },
  { name: "Wed", revenue: 6400 },
  { name: "Thu", revenue: 11200 },
  { name: "Fri", revenue: 9800 },
  { name: "Sat", revenue: 4100 },
  { name: "Sun", revenue: 5050 },
];

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Dashboard</h1>
      </div>

      <div className="stats_boxes gap_m">
        <a href="/manage-users" className="cards">
          <figure>
            <img src="/static/images/user_icon.svg" alt="Total Users" />
          </figure>
          <h2>{kpiData.totalUsers}</h2>
          <p>Total Users</p>
        </a>

        <a className="cards" href="/manage-users">
          <figure>
            <img src="/static/images/user_icon.svg" alt="New Users" />
          </figure>
          <h2>{kpiData.newUsers}</h2>
          <p>New Users</p>
        </a>

        <a className="cards" href="/manage-products">
          <figure>
            <img src="/static/images/user_icon.svg" alt="New Product" />
          </figure>
          <h2>{kpiData.newListing}</h2>
          <p>New Product</p>
        </a>

        <a className="cards" href="/manage-products">
          <figure>
            <img src="/static/images/user_icon.svg" alt="Total Products" />
          </figure>
          <h2>{kpiData.totalListedProducts}</h2>
          <p>Total Products</p>
        </a>

        <div className="cards">
          <figure>
            <img src="/static/images/reward_icon.svg" alt="Total Revenue" />
          </figure>
          <h2>{kpiData.totalRevenue}</h2>
          <p>Total Revenue</p>
        </div>
      </div>

      <div className="grid_sc gap_m">
        {/* Users & Listed Products Chart */}
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Users</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
              <Button className="btn btn_black icon_btn">
                <FileDownloadIcon />{" "}
              </Button>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={usersProductsData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="users" fill="#38B6FF" />
              {/* <Bar dataKey="products" fill="#82ca9d" /> */}
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Products</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
              <Button className="btn btn_black icon_btn">
                <FileDownloadIcon />{" "}
              </Button>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={usersProductsData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              {/* <Bar dataKey="users" fill="#38B6FF" /> */}
              <Bar dataKey="products" fill="#82ca9d" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        {/* <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Revenue</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
               <Button className="btn btn_black icon_btn"><FileDownloadIcon /> </Button>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={revenueData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="revenue" fill="#ffc658" />
            </BarChart>
          </ResponsiveContainer>
        </div> */}
      </div>
      {/* <div className="cards cards table_card mt_20">
        <div className="main_title">
          <h2>Recent User Activities  <span> (Latest 10) </span> </h2>
        </div>
        <RecentActivities />
      </div> */}
    </>
  );
};

export default Dashboard;
